/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_EmailInputs */

const en_enum_setting_data_type_email = /** @type {(inputs: Enum_Setting_Data_Type_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type Email`)
};

const de_enum_setting_data_type_email = /** @type {(inputs: Enum_Setting_Data_Type_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ Email`)
};

/**
* | output |
* | --- |
* | "Data Type Email" |
*
* @param {Enum_Setting_Data_Type_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_email = /** @type {((inputs?: Enum_Setting_Data_Type_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_email(inputs)
	return de_enum_setting_data_type_email(inputs)
});